import { getContext } from '@/context';
import { isGenaiRoute } from '@/utils/environment/surface';

/**
 * Closes the miniapp. On the GenAI Studio route, navigates to /create instead
 * of closing — the host editor manages closing there.
 */
export const closeMiniapp = async (): Promise<void> => {
  try {
    if (isGenaiRoute()) {
      getContext().handlers.navigate('/create', undefined, undefined);
      return;
    }
    await getContext().handlers.close();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[closeMiniapp] Failed to close miniapp:', error);
  }
};
